import React, { Component } from "react";
import { Button } from "reactstrap";
import { AdminService } from "../../generated";
export interface State {
  isLoaded: boolean;
  result: string;
}

export class AdminToken extends Component<{}, State> {
  constructor(props: {}) {
    super(props);

    this.state = {
      isLoaded: false,
      result: "",
    };
  }

  async componentDidMount() {
    try {
      const result = await AdminService.adminGetToken();
      this.setState({
        isLoaded: true,
        result: result.token,
      });
    } catch (e: any) {
      this.setState({
        isLoaded: true,
        result: e,
      });
    }
  }

  render() {
    const { isLoaded, result } = this.state;
    if (!isLoaded) {
      return <div>Loading...</div>;
    } else {
      return (
        <div>
          <div>
            <h3 className="pb-4 pt-4">Your token</h3>
          </div>
          <div style={{ wordWrap: "break-word" }}>{result}</div>
          <Button
            onClick={() => {
              navigator.clipboard.writeText(result);
            }}
          >
            Copy to clipboard
          </Button>
        </div>
      );
    }
  }
}
